import type { ProjectStatus } from '@nsb/core';
import { PauseMark } from './drawings.tsx';
import { statusTag } from './statusTag.ts';
import { Tag } from './ui.tsx';

/** The tag beside a project's name, by the one rule (`statusTag.ts`); nothing for one under way. */
export function ProjectStatusTag({ status }: { status: ProjectStatus }) {
  const t = statusTag(status);
  if (!t) return null;
  return (
    <Tag tone={t.tone}>
      {t.mark === 'pause' ? <PauseMark /> : null}
      {t.words}
    </Tag>
  );
}
